<template>
  <div class="success-banner text-center">
    <div class="circle-icon-background bg-primary mx-auto">
      <i class="icon-ok" />
    </div>

    <div class="fw-bold mt-3">
      {{ i18n.t('public.petitions.successful') }}
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.success-banner {
  .circle-icon-background {
    width: 97px;
    height: 97px;
    border-radius: 50%;
    color: white;
    font-size: 70px;
    line-height: 97px
  }
}
</style>
